<div class="vl-code-preview">
	<button class="vl-code-preview__btn" (click)="copyText()">
		<vl-icon name="vli_copy"> </vl-icon>
	</button>
	<ng-content></ng-content>
</div>
